<template>
  <BaseContent
    v-bind="{ ...$attrs, ...$props }"
    :contentable-id="getSiteId"
    contentable-type="site"
    :content="content"
    @saveContent="saveContent"
    @saveDelete="saveDelete"
    v-on="$listeners"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SiteContent',
  props: {
    contentKey: {
      type: String,
      required: true,
    },
    defaultContent: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('site', ['getSiteContentByKey', 'getSiteId']),
    content() {
      let siteContent = this.getSiteContentByKey(this.contentKey)
      return typeof siteContent === 'undefined'
        ? this.defaultContent
        : siteContent
    },
  },
  methods: {
    ...mapActions('site', ['updateSiteContent']),
    async saveContent(value) {
      await this.updateSiteContent({
        key: this.contentKey,
        value,
      })
    }, // saveContent
    async saveDelete() {
      await this.updateSiteContent({
        key: this.contentKey,
        value: null,
      })
    }, // saveDelete
  }, // methods
}
</script>
